
import { Component, Prop, Vue, Getter } from "nuxt-property-decorator";
import { Filter, Options } from "@/types/components";
import { FilterSelected } from "@/types/modal/interface";
import { BIcon, BIconSortAlphaUp, BIconSortAlphaDown, BIconSortNumericUp, BIconSortNumericDown, BIconSortUp, BIconSortDown, BIconSortAlphaDownAlt, BIconSortNumericDownAlt } from "bootstrap-vue";

@Component({
  components: {
    BIcon,
    BIconSortAlphaUp,
    BIconSortAlphaDown,
    BIconSortNumericUp,
    BIconSortNumericDown,
    BIconSortUp,
    BIconSortDown,
    BIconSortAlphaDownAlt,
    BIconSortNumericDownAlt
  },
})
export default class TheModalSort extends Vue {
  @Prop({default: []}) options: Array<any>;
  @Prop() value!: any;

  public select(event: any) {
    this.$emit('select-sort', event);
  }
}
